export function isAiPhoto(url: string | null | undefined): boolean {
  return !!url && url.startsWith("/api/photos/");
}

export function withWidth(url: string | null | undefined, width: number): string | null | undefined {
  if (!url) return url;
  if (!url.startsWith("/api/photos/") && !url.startsWith("/api/avatars/")) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}w=${width}`;
}
